import React, { useState, useRef, useEffect } from 'react';
import Draggable from 'react-draggable'; 
import '../../../Assets/Stylesheets/Pages/MarketingServices/OptionCustomSocials.scss';

// Import all the platform logos
import youtubeLogo from '../../../Assets/Images/Youtube_logo.png';
import facebookLogo from '../../../Assets/Images/Facebook_logo.png';
import instagramLogo from '../../../Assets/Images/Instagram_logo.png';
import tiktokLogo from '../../../Assets/Images/Tiktok_logo.png';
import xLogo from '../../../Assets/Images/X_logo.png';
import spotifyLogo from '../../../Assets/Images/Spotify_logo.png';
import snapchatLogo from '../../../Assets/Images/Snapchat_logo.png';

// Array to hold the platforms' data
const platforms = [
  { id: 'youtube', name: 'YouTube', logo: youtubeLogo },
  { id: 'facebook', name: 'Facebook', logo: facebookLogo },
  { id: 'instagram', name: 'Instagram', logo: instagramLogo },
  { id: 'tiktok', name: 'TikTok', logo: tiktokLogo },
  { id: 'x', name: 'X', logo: xLogo },
  { id: 'spotify', name: 'Spotify', logo: spotifyLogo },
  { id: 'snapchat', name: 'Snapchat', logo: snapchatLogo },
];


function OptionCustom() {
  const [selectedPlatforms, setSelectedPlatforms] = useState({});
  const [customMetrics, setCustomMetrics] = useState({
    publications: 0,
    followers: 0,
    likes: 0,
    comments: 0,
  });

  
  // Function to handle slider input changes
  const handleSliderChange = (metric, value) => {
    setCustomMetrics(prevMetrics => ({
      ...prevMetrics,
      [metric]: Number(value)
    }));
  };

  const handleCheckboxChange = (platformId) => {
    setSelectedPlatforms(prev => ({
      ...prev,
      [platformId]: !prev[platformId],
    }));
  };


  const circleCenter = { x: 150, y: 150 };
  const [cursorPos, setCursorPos] = useState({ x: circleCenter.x, y: circleCenter.y });
  const [percentages, setPercentages] = useState({});
  const circleRadius = 120;
  
  // This function will ensure that the cursor stays within the circle
  const handleDrag = (e, data) => {
    const dx = data.x - circleCenter.x;
    const dy = data.y - circleCenter.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
  
    if (distance <= circleRadius) {
      setCursorPos({ x: data.x, y: data.y });
    }
  };
  
  

  const calculatePercentages = () => {
    // Assuming an equal distribution for the demonstration
    const platformCount = Object.values(selectedPlatforms).filter(Boolean).length;
    if (platformCount === 0) return;

    const equalPercentage = 100 / platformCount;
    const newPercentages = {};

    Object.keys(selectedPlatforms).forEach(platformKey => {
      if (selectedPlatforms[platformKey]) {
        newPercentages[platformKey] = equalPercentage;
      }
    });

    setPercentages(newPercentages);
  };

  // Update percentages when the cursor is moved or when selected platforms change
  useEffect(() => {
    calculatePercentages();
  }, [cursorPos, selectedPlatforms]);

  return (
    <div className="option-custom-container">
      <div className="platform-options-container">
        {platforms.map((platform) => (
          <div key={platform.id} className="platform-option">
            <img src={platform.logo} alt={platform.name} className="platform-logo" />
            <input
              type="checkbox"
              id={platform.id}
              checked={!!selectedPlatforms[platform.id]}
              onChange={() => handleCheckboxChange(platform.id)}
            />
            <label htmlFor={platform.id}>{platform.name}</label>
          </div>
        ))}
      </div>

      <div className="custom-metrics-container">
        <div className="slider-container">
          <label htmlFor="publications-slider">Monthly Publications</label>
          <input
            type="range"
            id="publications-slider"
            min="0"
            max="90"
            value={customMetrics.publications}
            onChange={(e) => handleSliderChange('publications', e.target.value)}
          />
          <output>{customMetrics.publications}</output>
        </div>

        <div className="slider-container">
          <label htmlFor="followers-slider">Follower Growth</label>
          <input
            type="range"
            id="followers-slider"
            min="0"
            max="25000"
            value={customMetrics.followers}
            onChange={(e) => handleSliderChange('followers', e.target.value)}
          />
          <output>{customMetrics.followers}</output>
        </div>

        <div className="slider-container">
          <label htmlFor="likes-slider">Likes</label>
          <input
            type="range"
            id="likes-slider"
            min="0"
            max="25000"
            value={customMetrics.likes}
            onChange={(e) => handleSliderChange('likes', e.target.value)}
          />
          <output>{customMetrics.likes}</output>
        </div>

        <div className="slider-container">
          <label htmlFor="comments-slider">Comments</label>
          <input
            type="range"
            id="comments-slider"
            min="0"
            max="5000"
            value={customMetrics.comments}
            onChange={(e) => handleSliderChange('comments', e.target.value)}
          />
          <output>{customMetrics.comments}</output>
        </div>
          
        {/* Optimizer with draggable cursor */}
      <div className="optimizer-container">
      <div 
      className="optimizer-container" 
      style={{ minHeight:'400px' }}
      >
  <svg
    width="300"
    height="300"
    viewBox="0 0 300 300"
    className="circle-optimizer"
    style={{ position: 'absolute', left: '40%', marginTop: '10px' }}
  >
    <circle cx="150" cy="150" r="120" stroke="black" strokeWidth="3" fill="transparent" />
    {/* Render platform logos at equidistant points on the circle */}
    {Object.keys(selectedPlatforms)
      .filter(key => selectedPlatforms[key]) // Filter only selected platforms
      .map((platform, index, array) => {
        const angle = (index / array.length) * 2 * Math.PI; // Calculate angle for placement
        const x = 150 + 120 * Math.cos(angle);
        const y = 150 + 120 * Math.sin(angle);
        return (
          <image
            key={platform}
            href={platforms.find(p => p.id === platform).logo}
            x={x - 15} // Offset by half the image size for centering
            y={y - 15} // Offset by half the image size for centering
            height="30"
            width="30"
          />
        );
      })}
  </svg>


        <Draggable 
          onDrag={handleDrag} 
          position={{ x: cursorPos.x, y: cursorPos.y }} 
          bounds="parent"
        >
          <svg 
            x={cursorPos.x - 10} // Offset by radius of the cursor circle
            y={cursorPos.y - 10} // Offset by radius of the cursor circle
            width="20" 
            height="20"
            style={{ overflow: 'visible', position: 'absolute', cursor: 'pointer',left:'40%' }}
          >
          
            <circle cx="10" cy="10" r="10" fill="black" />
          </svg>
        </Draggable>
        </div>
      </div>
      {
        
      }
    <div className="option-custom-container">
      {/* ...rest of your component... */}
      <div className="optimizer-container">
        {/* ...SVG and Draggable components... */}
      </div>
      {/* Display the calculated percentages */}
      <div className="percentages-display">
        {Object.entries(percentages).map(([platformKey, percentage]) => (
          <p key={platformKey}>{`${platforms.find(p => p.id === platformKey).name}: ${percentage.toFixed(2)}%`}</p>
        ))}
      </div>

      <p className="total-cost">
            Total Social Media Growth Plan Cost:
          </p>

    </div>

          
      
      </div>
    </div>
  );
}

export default OptionCustom;